import {SyntheticEvent, useCallback} from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {useProductQuery} from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";
import {ILocation, RentalLocationType} from "../../../../../../types";
import { IFormValues } from "../../../../types";
import LocationHelperText from "../location-helper-text/location-helper-text";
import {useQueryClient} from "@tanstack/react-query";
import dayjs from "dayjs";
import { convertUtcToTzIsoDayJs } from "../../../../../../../../util/timezoneConversion";

const FormPickupLocation = () => {
    const { t } = useTranslation('booking');
    const formContext = useFormContext<IFormValues>();
    const queryClient = useQueryClient();

    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });
    const pickupLocationWatch = useWatch<IFormValues, 'basicDetails.pickupLocation'>({
        name: 'basicDetails.pickupLocation'
    });
    var timezone: string | undefined = pickupLocationWatch?.zoneId ?? undefined;

    const tenant = useWatch({ control: formContext.control, name: "basicDetails.tenant" });
    const dealer = useWatch({ control: formContext.control, name: "basicDetails.dealer" });

    const productQuery = useProductQuery(
        {
            segment: rentalType,
            businessContinuityInsToolMode:false,
            tenant: tenant as string,
            dealer: dealer as string
        },
        {
            refetchOnMount: false
        }
    );

    function updateTimeZone(value: ILocation | null) {
        if (timezone != value?.zoneId) {
            timezone = value?.zoneId
            formContext.setValue(
                'basicDetails.pickupDate',
                convertUtcToTzIsoDayJs(dayjs().add(15, 'm').toISOString(), timezone)
            );
            formContext.setValue(
                'basicDetails.dropoffDate',
                convertUtcToTzIsoDayJs(dayjs().add(3, 'day').add(15, 'm').toISOString(), timezone)
            );
            formContext.setValue(
                'basicDetails.dropoffDate',
                convertUtcToTzIsoDayJs(dayjs().add(3, 'day').add(15, 'm').toISOString(), timezone)
            );
            formContext.setValue(
                'basicDetails.pickupLocationTimezone',
                value?.zoneId ?? "Europe/Rome"
            );
        }
    }

    const onChange = useCallback((_: SyntheticEvent<Element, Event>, value: ILocation | null) => {
        if (value) {
            formContext.trigger('basicDetails.pickupLocation');
        }
        formContext.trigger('basicDetails.pickupDate');

        updateTimeZone(value)
    }, [])

    return (
        <FormAutocomplete<IFormValues>
            name="basicDetails.pickupLocation"
            label={t('label.pickupLocation')}
            options={productQuery.data?.locations ?? []}
            onChange={onChange}
            loading={productQuery.isLoading}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            textFieldProps={{
                helperText: <LocationHelperText location={pickupLocationWatch} locationType={RentalLocationType.Pickup} />
            }}
        />
    );
}

export default FormPickupLocation;
